/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Upgrade_CtaInputs */

const en_tts_tool_upgrade_cta = /** @type {(inputs: Tts_Tool_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert PDFs and articles`)
};

const es_tts_tool_upgrade_cta = /** @type {(inputs: Tts_Tool_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir PDFs y artículos`)
};

/**
* | output |
* | --- |
* | "Convert PDFs and articles" |
*
* @param {Tts_Tool_Upgrade_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_upgrade_cta = /** @type {((inputs?: Tts_Tool_Upgrade_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Upgrade_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_upgrade_cta(inputs)
	return en_tts_tool_upgrade_cta(inputs)
});